import React, { useEffect } from 'react'
import sortingUtils from '../../utils/sorting.utils'
import { filterFns } from '@tanstack/react-table'
import TableLayout from '../Common/DaisyTable/TableLayout';
import HeaderActions from './HeaderActions/MixturesHeaderActions';
import { TableProvider, useTable } from '../../context/TableContext';
import MixturesRowActions from './RowActions/MixturesRowActions';
import ReagentsModal from '../Capsules/ReagentsModal';
import Loading from '../Common/Loading/Loading';
import LoadingSpinner from '../Common/Loading/LoadingSpinner';

const MixturesTable = ({ type }) => {




  const mixturesDef = [
    {
      id: 'name',
      accessorFn: row => row.name,
      header: () => <span>Nom</span>,
      cell: info => <span>{info.getValue()}</span>,
      footer: props => props.column.id,
      filterFn: filterFns.includesString,
      sortingFn: sortingUtils.sortText,
    },
    {
      id: 'category',
      accessorFn: row => row.category,
      header: () => <span>Cat. Principale</span>,
      cell: info => <span>{info.getValue()}</span>,
      footer: props => props.column.id,
      sortingFn: sortingUtils.sortText,
      filterFn: filterFns.includesString,
      enableHiding: true,
      size: 50
    },
    {
      id: 'subCategory',
      accessorFn: row => row.subCategory,
      header: () => <span>Cat. Secondaire</span>,
      cell: info => <span>{info.getValue()}</span>,
      footer: props => props.column.id,
      sortingFn: sortingUtils.sortText,
      filterFn: filterFns.includesString,
      enableHiding: true,
      size: 50
    },
    {
      id: 'defaultDilution.label',
      accessorFn: row => row.defaultDilution.label,
      header: () => <span>Dilution</span>,
      cell: info => <span>{info.getValue()}</span>,
      footer: props => props.column.id,
      sortingFn: sortingUtils.sortText,
      filterFn: filterFns.includesString,
      enableHiding: true
      ,
      size: 50
    },
    {
      id: 'ref',
      accessorFn: row => row.ref,
      header: () => <span>Référence</span>,
      cell: info => <span>{info.getValue()}</span>,
      footer: props => props.column.id,
      sortingFn: sortingUtils.sortText,
      filterFn: filterFns.includesString,
      enableHiding: true,
      size: 50
    },
    {
      id: 'reagents',
      accessorFn: row => row.reagents,
      header: () => <span>Réactifs</span>,
      cell: (info) => <ReagentsModal mixtureName={info?.row?.original?.name} reagents={info.getValue()} description={info?.row?.original?.description} iconSize='sm' />,
      footer: props => props.column.id,
      filterFn: filterFns.arrIncludes,
      enableHiding: true,
      enableSorting: false


    },
    {
      id: 'actions',
      accessorFn: row => row.id,
      header: () => <span>Actions</span>,
      cell: info => <MixturesRowActions table={info.table} row={info.row} />,
      footer: props => props.column.id,
      enableResizing: false, //disable resizing for just this column
      enableGlobalFilter: false, //disable global filtering for just this column
      size: 50, //starting column size
    }
  ]

  const title = type === 'custom' ? 'Mélanges Personnalisés' : 'Catalogue'



  return (
    <div className='w-full max-w-screen-xl m-auto flex flex-col gap-4'>
      <h1 className='text-5xl text-center'>{title}</h1>
      <TableProvider API_URL={`/mixtures/${type}`}>
        <TableLayout headers={mixturesDef} width={'100%'} withCheckbox >
          <HeaderActions type={type} />
        </TableLayout>
      </TableProvider>
    </div>
  )
}

export default MixturesTable
